/* eslint-disable react/no-multi-comp */
import React from "react";
import { DisplayComponent } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import type { NewsletterHook } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { HomepageV2ThemeFindOutMore } from "./homepage-v2-theme-find-out-more";
import { SignUpNewsletter } from "./homepage-v2-theme-sign-up-newsletter";
import { SignUpSuccessMessage } from "./homepage-v2-theme-sign-up-success-message";

export const useHomepageV2Render: NewsletterHook = onSuccess => ({
  [DisplayComponent.FindOutMore]: _props => <HomepageV2ThemeFindOutMore />,
  [DisplayComponent.SignUpNewsletter]: props => (
    <SignUpNewsletter isShowOverlaySignUp onSuccess={onSuccess} {...props} />
  ),
  [DisplayComponent.SignUpSuccessMessage]: _props => <SignUpSuccessMessage />,
});
